import React from 'react';
import Truncate from 'react-truncate';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { CoreLink, DynamicMediaItem } from '@uncinc/react-drupal-core';
import {
  WysiwygField,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import { TaxonomyThemes } from '../../../../types/uncinc_profile/taxonomy';

import './style.scss';

interface TaxonomyThemeTeaserProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<TaxonomyThemes>;
  classes: string;
}

const TaxonomyThemeTeaser: React.FC<TaxonomyThemeTeaserProps> = ({ entity, classes, ...props }) => {
  const { t } = useTranslation();
  const theme = entity.toJS();
  const name = theme.name[0].value;
  const description = theme.description[0].value;
  const url = theme.paths.nl;
  const media = theme.field_media_item;

  const TeaserImg = media.map((teaserItem) => (
    <DynamicMediaItem
      media={teaserItem}
      imageAspectRatio="4_3"
    />
  ));

  return (
    <div className={classNames('ThemeTeaser', classes)} {...props}>
      <div className="ThemeTeaser__image">
        {TeaserImg}
      </div>
      <div className="ThemeTeaser__content">
        <div className="ThemeTeaser__content__title">
          <CoreLink className="teaser-link" href={url}>
            <h3>{name}</h3>
          </CoreLink>
          <div className="ThemeTeaser__content__body">
            <Truncate lines={3} ellipsis="...">
              <WysiwygField
                html={description}
              />
            </Truncate>
          </div>
        </div>

        <div className="ThemeTeaser__content__action">
          <div>
            {t('organisms.text.read_more')}
            <span className="icon icon-arrow-right icon-variant-4" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaxonomyThemeTeaser;
